/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
import Global from './global';

'use strict';
const EqualHeightsItems = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeight();
	},

	/** @description slider example description e.g Banner slider */
	equalHeight: () => {
		Global.functions.equalHeights($('.js-categories-equal-heights'));
		Global.functions.equalHeights($('.js-banner-title-equal-height'));
		Global.functions.equalHeights($('.js-search-wrap .js-product-info-box__title'));
		/* Global.functions.equalHeights($('.product-info-box__product-desc'));
		Global.functions.equalHeights($('.product-info-box__product-desc--alt')); */
	},
};

export default EqualHeightsItems;
